import React from 'react';
import {
  Dialog,
  IconButton,
  List,
  ListItem,
  Button,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { SvgCloseRegular } from '@insights-ltd/design-library/components';
import { logout } from 'api';
import { useAuth } from 'components/Authentication/AuthenticationProvider';
import HeaderLayout from './HeaderLayout';

type MobileNavBarDialogProps = {
  open: boolean;
  closeDialog: () => void;
};

const MobileNavBarDialog = ({ open, closeDialog }: MobileNavBarDialogProps) => {
  const { username: loggedIn } = useAuth();

  const doLogout = async () => {
    if (
      /* eslint no-alert: "off" */
      window.confirm(
        'Are you sure you’d like to sign out? You may be signed in to other tools using the same credentials; if you sign out here, you may be required to sign in again elsewhere.',
      )
    ) {
      await logout();
    }
  };

  return (
    <Dialog fullScreen open={open} onClose={closeDialog}>
      <HeaderLayout>
        <Grid
          container
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <IconButton
            onClick={closeDialog}
            aria-label="Close Button"
            size="small"
          >
            <SvgCloseRegular />
          </IconButton>
        </Grid>
      </HeaderLayout>
      <List>
        {loggedIn ? (
          <>
            <ListItem>
              <Typography>{loggedIn}</Typography>
            </ListItem>

            <ListItem>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => {
                  doLogout().then();
                }}
              >
                Log Out
              </Button>
            </ListItem>
          </>
        ) : null}
      </List>
    </Dialog>
  );
};

export default MobileNavBarDialog;
